import { observer } from "mobx-react-lite"
import React, { FC, useCallback, useEffect, useState } from "react"
import { Appearance, ViewStyle } from "react-native"
import { Screen, Text } from "../../../../../components"
// import { useStores } from "../../models"
import { CompositeScreenProps } from "@react-navigation/native"
import { color } from "../../../../../theme"
import { useStores } from "../../../../../models"
import { createAxios } from "../../../../../utils/axios"
import config from "../../../../../utils/config"
import WebView from "react-native-webview"
import { Spinner } from "native-base"


const ROOT: ViewStyle = {
  flexGrow: 1,
}

const { BASE_URL } = config();

export const CustomFrTableScreen: FC<{ colorScheme?: "light" | "dark" } & CompositeScreenProps<any, any>> = observer(function CustomFrTableScreen(props) {
  const { colorScheme = "light" || Appearance.getColorScheme() } = props

  const [ cacheKey, setCacheKey ] = useState<string>(null);
  const [ url, setUrl ] = useState<string>(null);
  const [ loading, setLoading ] = useState<boolean>(true);

  // Pull in one of our MST stores
  const { appStore: { farmId } } = useStores()

  const getCacheToken = () => {
    return createAxios().post('request_access')
      .then(({ data: { data }}) => setCacheKey(data.cache_key))
  }

  useEffect(() => {
    getCacheToken()
    .catch(() => {})
    .finally(() => setLoading(false))
  }, [])

  useEffect(() => {
    const uri = `${BASE_URL}/web_view/farms/${farmId}/farm_fr_tables?cache_key=${cacheKey}`
    if (cacheKey) setUrl(uri);
  },[cacheKey, farmId])

  const FRTableWebview = useCallback(() => {
    return <WebView onLoad={() => setLoading(false)} source={{ uri: url }} startInLoadingState />
  }, [url])

  return (
    <Screen 
      style={ROOT} 
      preset="scroll"
      colorScheme={colorScheme}
      backgroundBar={colorScheme === "light" ? color.primary : undefined}
      statusBar={colorScheme === "light" ? "light-content" : "dark-content"}
    >
      <FRTableWebview />
    </Screen>
  )
})
